module.exports = __webpack_public_path__ + "img/abo2o.c2e6579.png";